import "./secondaryBtn.css";

type BtnInstance = {
  type?: "button" | "submit" | "reset";
  text: any;
  svgBefore?: any;
  svgAfter?: any;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
};

export function SecondaryButton({ btn }: { btn: BtnInstance }) {
  return (
    <button type={btn.type || "button"} onClick={btn.onClick} className="btn btn-secondary">
      {btn.svgBefore && <div style={{ marginRight: 5, display: "flex" }}>{btn.svgBefore}</div>} {btn.text}{" "}
      {btn.svgAfter && <div style={{ marginLeft: 5, display: "flex" }}>{btn.svgAfter}</div>}
    </button>
  );
}
